// START_MODULE components_molecules_news_news_tsx
// START_CONTRACT
// PURPOSE: Render a news preview or its full detail view.
// OPERATIONAL_CONTEXT: Used by the paginated archive and individual news routes.
// CONTRACT: Preview mode shows the maintained summary and links internally; full mode prefers the original complete text and exposes its Telegram source.
// KEYWORDS: news, preview, details, telegram-source
// COMPLEXITY: 3
// END_CONTRACT
import React, { useEffect, useState } from 'react';

import {
  NewsImage, NewsTitle, NewsSubtext, NewsContent, LinkWrapper, NewsContentLimited,
} from './styled';

import { Link, LinkRouter } from 'components/atoms/link/Link';
import ArrowRight from 'components/atoms/icons/ArrowRight';

import { mainRepository } from 'domain/repositories/MainRepository';
import { INews } from 'domain/entities/INews';

import { route } from 'routes/route';

import { getDateTime } from 'utils/date/getDateTime';

interface NewsProps {
  news: INews;
  full?: boolean;
}

const News: React.FC<NewsProps> = ({ news, full = false }) => {
  const [imageSrc, setImageSrc] = useState<string>('');

  useEffect(() => {
    mainRepository.getImageFile(news.imageHeaderId)
      .then((blob) => URL.createObjectURL(blob))
      .then((src) => setImageSrc(src));
  }, [news.imageHeaderId]);

  return (
    <div>
      <NewsImage src={imageSrc} />
      {
        full ? (
          <NewsTitle>{news.header}</NewsTitle>
        ) : (
          <LinkRouter to={route.newsDetails(news.id)} $underline={false}>
            <NewsTitle>{news.header}</NewsTitle>
          </LinkRouter>
        )
      }
      <NewsSubtext>{getDateTime(news.dateAdded)}</NewsSubtext>

      {
        full ? (
          <>
            <NewsContent className="formatted-text" dangerouslySetInnerHTML={{ __html: news.fullContent ?? news.content }} />
            {
              news.video && (
                <div className="video-embed">
                  <iframe
                    src={news.video.embedUrl}
                    title={news.video.title}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                </div>
              )
            }
            {
              news.sourceUrl && (
                <Link href={news.sourceUrl} target="_blank" rel="noreferrer">
                  Публикация в Telegram
                </Link>
              )
            }
          </>
        ) : (
          <NewsContentLimited className="formatted-text" dangerouslySetInnerHTML={{ __html: news.content }} />
        )
      }

      {
        !full && (
          <LinkWrapper>
            <LinkRouter to={route.newsDetails(news.id)}>
              Подробнее
              <ArrowRight />
            </LinkRouter>
          </LinkWrapper>
        )
      }
    </div>
  );
};

export default News;

// END_MODULE components_molecules_news_news_tsx
